<script setup lang="ts">
import { tv } from "tailwind-variants";

const variants = tv({
  slots: {
    playIcon: "",
    playButton: "",
  },
  variants: {
    theme: {
      "green-seagreen": {
        playIcon: "[--video-play-background:var(--color-seagreen-40)] [--video-play-fill:var(--color-yellow-15)]",
        playButton: "bg-seagreen-50 text-yellow-15",
      },
      "dark-red-pink": {
        playIcon: "[--video-play-background:var(--color-seagreen-40)] [--video-play-fill:var(--color-yellow-15)]",
        playButton: "bg-seagreen-50 text-yellow-15",
      },
      "blue-pink": {
        playIcon: "[--video-play-background:var(--color-coral-20)] [--video-play-fill:var(--color-blue-50)]",
        playButton: "bg-coral-10 text-blue-50",
      },
      "green-red": {
        playIcon: "[--video-play-background:var(--color-seagreen-40)] [--video-play-fill:var(--color-red-10)]",
        playButton: "bg-seagreen-50 text-red-10",
      },
    },
  },
});

const packet = inject(keys.currentPacket);

const classes = computed(() => variants({ theme: unref(packet)?.theme }));

const video = computed(() => unref(packet)?.videoAdv);

const [playing, toggle] = useToggle(false);

const bg = computed(() => `url(${video.value?.placeholderImage?.url || usePublicAssetUrl("/images/videofreezeunivers.jpg")})`);
</script>

<template>
  <section
    v-if="video?.url"
    class="relative bg-inherit pt-xs pb-20"
  >
    <UiGraphicsCurtain
      :data-curtain="playing ? 'out' : 'in'"
      class="absolute top-0 z-2"
    />
    <UContainer
      data-player-wrapper
      class="relative flex aspect-video flex-col items-center justify-center [--ui-container-inline-padding:0]"
    >
      <UiCommonsVideoPlayer
        v-if="playing"
        :url="video.url"
        :title="video.title"
        class="z-1 my-8"
        autoplay
        data-player
      />
      <button class="hover:contrast-75" @click="toggle()">
        <IconsGraphicsVideoPlay
          v-if="!playing"
          aria-hidden="true"
          :class="classes.playIcon()"
          class="relative z-1 mx-auto"
        />
        <span class="rounded-md px-6 py-3 text-lg-versal font-semibold uppercase" :class="classes.playButton()">
          {{ playing ? 'Stopp' : 'Se' }}&nbsp;filmen
        </span>
      </button>
    </UContainer>
  </section>
</template>

<style scoped>
[data-curtain] {
  animation-duration: 1.2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
  animation-fill-mode: both;
}

[data-curtain="out"] {
  animation-name: slideOut;
}

[data-curtain="in"] {
  animation-name: slideIn;
}

[data-player] {
  animation-name: fadeIn;
  animation-duration: 1.8s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
}

[data-player-wrapper] {
  background-image: v-bind(bg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-clip: content-box;
  -webkit-background-clip: content-box;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  0% {
    transform: translateY(-100%);
    background: transparent;
  }
  50% {
    background: var(--curtain);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes slideOut {
  50% {
    background: var(--curtain);
  }
  100% {
    transform: translateY(-100%);
    background: transparent;
  }
}
</style>
